<template>
  <div class="listGroup"></div>
</template>

<script>
import Vue from "vue";
import { Toast } from "vant";
Vue.use(Toast);
import { initiateBusinessOrder,baseUrl } from "../../assets/js/api";
export default   {
  data() {
    return {
      form: {
        officeCode: "",
        busCode: "",
        channelCode: "",
        channelType:""
      },
    };
  },
  created() {
    document.title = "请稍后..."
    this.jump();
  },
  methods: {
    jump() {
      // 判断路由里面是否有developCode
      // if (this.$route.query.developCode) {
        this.form.officeCode = this.$route.query.officeCode;
        this.form.busCode = this.$route.query.busCode;
        this.form.channelCode = this.$route.query.channelCode;
        this.form.channelType = this.$route.query.channelType;  
        // if (this.form.developCode != "") {
          baseUrl('/business/v1/initiateBusinessOrder',this.form)
            .then((res) => {
              if (res.data.code == "0000") {
                console.log(res)
                let handurl = res.data.applyUrl;
                window.location.href=handurl;
              }else{
                Toast(res.data.msg);
              }
            })
            .catch((err) => {
              console.log(err);
              Toast("您的网络走丢了");
            });
        // } else {
        //   Toast("请刷新重试");
        // }
      // } else {
      //   Toast("参数异常，请重新打开页面");
      // }
    },
  },
};
</script>   

<style scoped>
</style>